// export interface LifestyleCategory {
//   icon: string;
//   title: string;
//   description: string[];
// }

export interface LifestyleCategory {
  id: string;
  icon: string;
  name: string;
  description: string;
  examples: string[];
}

export const lifestyleCategories: LifestyleCategory[] = [
  // {
  //   icon: "🏠",
  //   title: "Home & Daily Life",
  //   description: [
  //     "House cleaning services",
  //     "Laundry/dry cleaning pickup",
  //     "Grocery delivery memberships (e.g., Instacart+)",
  //     "Meal kit subscriptions (e.g., Goodfood, HelloFresh)",
  //     "Home office furniture (chair, desk, monitor stand)",
  //     "Smart home devices (e.g., lighting, speakers)"
  //   ]
  // },
  {
    id: "home-daily-life",
    icon: "🏠",
    name: "Home & Daily Life",
    description: "Home and daily life services and memberships (no office gear)",
    examples: [
      "House cleaning services",
      "Laundry/dry cleaning pickup",
      "Grocery delivery memberships (e.g., Instacart+)",
      "Meal kit subscriptions (e.g., Goodfood, HelloFresh)",
      "Smart home devices (e.g., lighting, speakers)",
    ],
  },
  {
    id: "remote-work-productivity",
    icon: "💻",
    name: "Remote Work & Productivity",
    description: "Remote work expenses, home office furniture and productivity tools",
    examples: [
      "Co-working space fees",
      "Internet upgrades / partial reimbursements",
      "Tech accessories (mouse, webcam, keyboard)",
      "Standing desks, ergonomic tools",
      "Home office furniture (chair, desk, monitor stand)",
      "Blue light glasses",
    ],
  },
  {
    id: "transportation-eco-mobility",
    icon: "🚌",
    name: "Transportation & Eco-Mobility",
    description: "Eco-friendly and convenience transportation",
    examples: [
      "Public transit passes",
      "Bike share memberships",
      "E-bike or scooter purchase subsidy",
      "Car share memberships (e.g., Communauto, Zipcar)",
      "Car washes and detailing",
      "Winter tire change / storage",
    ],
  },
  {
    id: "culture-live-events",
    icon: "🎨",
    name: "Culture & Live Events",
    description: "Cultural experiences (museums, galleries, theatre, concerts)",
    examples: [
      "Museum or gallery passes",
      "Theatre or concert passes",
      "Festival tickets (music, arts, cultural)",
      "Comedy shows",
    ],
  },
  {
    id: "entertainment-subscriptions",
    icon: "🎭",
    name: "Entertainment & Media",
    description: "Entertainment streaming, media and gaming",
    examples: [
      "Netflix, Disney+, Spotify",
      "Movie theatre passes",
      "Gaming subscriptions (Xbox, Playstation, Nintendo)",
      "Audiobooks & podcasts (Audible, Wondery+)",
    ],
  },
  {
    id: "learning-personal-growth",
    icon: "📚",
    name: "Learning & Personal Growth",
    description: "Courses, books and professional growth",
    examples: [
      "Courses (LinkedIn Learning, Coursera, Udemy)",
      "Creative class subscriptions (Masterclass, Skillshare)",
      "Language learning apps (Duolingo Plus, Babbel)",
      "Books and eBooks",
      "Conference tickets",
      "Career coaching",
      "Financial literacy workshops",
      "Public speaking classes",
    ],
  },
  {
    id: "hobbies-creative",
    icon: "🧶",
    name: "Hobbies & Creative Supplies",
    description: "Supplies and materials for creative hobbies and DIY",
    examples: [
      "Art supplies (paints, brushes, canvases)",
      "Craft materials (yarn, fabric, beads)",
      "DIY maker tools (non-professional)",
      "Model kits (scale models, LEGO kits)",
      "Photography accessories (tripods, filters, lighting)",
      "Musical instrument accessories",
    ],
  },
  {
    id: "wellness-self-care",
    icon: "💆",
    name: "Wellness & Self-Care",
    description: "Personal wellness and self-care",
    examples: [
      "Spa & massage (non-medical)",
      "Hairdresser / barber / grooming",
      "Meditation apps (Calm, Headspace)",
      "Personal stylist sessions",
      "Skincare, cosmetics, natural products",
      "Float therapy, infrared sauna",
    ],
  },
  {
    id: "travel-experiences",
    icon: "🌍",
    name: "Travel & Experiences",
    description: "Travel credits and local experiences",
    examples: [
      "Airbnb / hotel credits",
      "Airline gift cards",
      "Local tourism activities",
      "Retreats & group experiences (yoga, adventure trips)",
    ],
  },
  {
    id: "fashion-style",
    icon: "👔",
    name: "Fashion & Style",
    description: "Clothing, workwear and accessories",
    examples: [
      "Clothing / shoes",
      "Workwear allowances",
      "Glasses (non-prescription/sunglasses)",
      "Blue light glasses",
      "Jewelry, watches, accessories",
    ],
  },
  {
    id: "fitness-sports",
    icon: "🏋️",
    name: "Fitness & Sports",
    description: "Fitness memberships and sports activities",
    examples: [
      "Fitness class passes (ClassPass, spin, boxing)",
      "Sports equipment (rackets, mats, shoes)",
      "Gym memberships",
      "Sports league fees (hockey, soccer, golf, etc.)",
    ],
  },
  {
    id: "food-nutrition",
    icon: "🍱",
    name: "Food & Nutrition",
    description: "Food-related credits and nutrition",
    examples: [
      "Coffee shop credits",
      "Farmer's market gift cards",
      "Cooking classes",
      "Nutritionist consultations (non-medical)",
    ],
  },
  {
    id: "pet-care",
    icon: "🐕",
    name: "Pet Care",
    description: "Pet care services and products",
    examples: [
      "Pet insurance premiums",
      "Vet visit reimbursements (non-HSA)",
      "Grooming & training services",
      "Pet daycare & boarding",
    ],
  },
  {
    id: "relationships-fun",
    icon: "💕",
    name: "Relationships & Fun",
    description: "Social activities and family fun",
    examples: [
      "Date night expenses",
      "Babysitting reimbursement",
      "Board games & card games",
      "Escape rooms",
      "Karaoke night",
    ],
  },
  {
    id: "consumer-subscriptions-perks",
    icon: "📦",
    name: "Consumer Subscriptions & Perks",
    description: "Consumer memberships and utility/perk bundles (non-media)",
    examples: [
      "Amazon Prime",
      "Costco/Bulk memberships",
      "Cloud storage or password manager subscriptions",
      "Paid mobile productivity apps (task managers, habit trackers)",
    ],
  },
  {
    id: "family-kids",
    icon: "👨‍👩‍👧‍👦",
    name: "Family & Kids",
    description: "Family activities and childcare",
    examples: [
      "Summer camp fees",
      "Extracurriculars (music, dance, coding, art)",
      "Family activity passes (zoos, aquariums, amusement parks)",
      "Daycare",
    ],
  }
];
